import { render } from "./englishImproveUploadVideo.vue?vue&type=template&id=57ecb220&scoped=true"
import script from "./englishImproveUploadVideo.vue?vue&type=script&lang=js"
export * from "./englishImproveUploadVideo.vue?vue&type=script&lang=js"

import "./englishImproveUploadVideo.vue?vue&type=style&index=0&id=57ecb220&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57ecb220"]])

export default __exports__